import { updateUndoRedoControls } from '~core';
import { getState, incrementState, modifyState } from '~src/state';
import { convertTextboxesToSpellCheck } from '~core/spellcheck';
import checkSpellingDebounced from '~core/spellcheck/checkSpellingDebounced';

export const editorRedo = () => {
  const currentPageIndex = getState('currentPageIndex');
  const currentHistoryIndex = getState(
    `currentHistoryIndex[${currentPageIndex}]`
  );
  const history = getState(`history[${currentPageIndex}]`, []);

  if (currentHistoryIndex === history.length - 1) {
    console.error('Cannot redo! There is no a next step');
    return false;
  }

  modifyState('redoInProgress', true);
  incrementState(`currentHistoryIndex[${currentPageIndex}]`);

  const nextState = history[currentHistoryIndex + 1];

  window.canvas.loadFromJSON(nextState, async () => {
    modifyState('redoInProgress', false);
    window.canvas.renderAll();
    await convertTextboxesToSpellCheck(window.canvas);
    updateUndoRedoControls();

    // Use debounced spellcheck to avoid excessive checking during rapid undo/redo
    checkSpellingDebounced(window.canvas);
  });
};
